import axios from 'axios';

import AppConfig from '../config/config';

const axiosInstance = axios.create({
  baseURL: AppConfig.apiGateway.BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    if (!config.headers.Authorization) {
      const jwt = localStorage.getItem(AppConfig.LOCAL_STORAGE_TOKEN_KEY);
      if (jwt !== '') {
        config.headers['auth-token'] = `${jwt}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
